var messages = {
  alert: {
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
    networkError: "Network error",
  },
  meta: {
    homePage: "Home",
    userPage: "Me",
    userManagement: "User management",
    systemLanguage: "System language",
    autoLanguage: "Follow the system",
    search: "Search",
    noMore: "No more",
    uploadSuccess: "Upload success",
    uploadFail: "Upload fail",
    loading: "Loading...",
    privacy1: "User Agreement",
    privacy2: "Privacy policy",
    privacy3: "Shipping policy",
    confirm: "Confirm",
    cancel: "Cancel",
    copySuccess: "Copy success",
    input: "Please input",
    select: "Please select",
    searchType: "Search conditions",
    allFilter: "All filter",
    kefuList: "Customer service",
    reset: "Reset",
    yes: "Yes",
    no: "No"
  },
  home: {
    title: "vTrack logistics station",
    freightInquiry: "Quotation",
    freightInquiryDetail: "Quotation detail",
    orderDetail: "Waybill",
    orderException: "Order exception handling",
    cargoInquiry: "Tracking",
    goodsForecast: "Purchase forecast",
    accountList: "Statement",
    shippingAddress: "Address",
    freightPriceCalculator: "Calculator",
    nickname: "Nickname",
    qrCode: "Pick-up QR code",
    payCompletion: "Payment detail",
    pointsList: "Points detail",
    shipNow: "Ship now",
    details: "Product detail"
  },
  auth: {
    login: "Log in",
    logInSuccess: "Log In success",
    inputPhoneNumber: "Please input the phone number",
    inputEmail: "Please input the email",
    inputCorrentPhoneNumber: "Please input the correct phone number",
    inputCorrentEmail: "Please input the correct email",
    phoneNumber: "Phone number",
    email: "Email",
    inputVcode: "Verification code",
    inputUsername: "Phone number / email / customer id",
    inputPassword: "Please input the password",
    inputCompanyCode: "Please input the company code",
    register: "Sign up",
    setAccountInfo: "Set account information",
    sendAuthCode: "SMS code",
    next: "Next",
    backLogin: "Back to login",
    verificationCodeInfo: "Verification code has been sent",
    username: "Username",
    inputPaw: "Please input your password",
    inputPaw2: "Please input the password again",
    registerSuccess: "Register successfully",
    correctError: "Please input the correct password first",
    confirm: "Confirm",
    logout: "Logout",
    customerNumber: "Customer number",
    companyName: "Prolinker Holdings (Guangzhou) Co., Ltd.",
    logoText: "China International Express",
    codeNotice: "Still waiting for OTP? Check your spam."
  },
  address: {
    addAddress: "Create delivery address",
    editAddress: "Edit delivery address",
    addressTitle: "Foreign delivery address",
    postcode: "Postcode",
    email: "Email",
    input: "Please input",
    select: "Please select",
    receivingName: "Consignee",
    phoneNumber: "Contact No.",
    country: "Country",
    city: "City",
    receivingAddress: "Delivery address details",
    isDefault: "Default delivery address",
    submit: "Submit",
    delete: "Delete",
    selectAddress: "Please select address",
    chinese1: "Your china delivery address",
    chinese2: "Warehouse",
    chinese3: "Contact",
    chinese4: "Phone",
    chinese5: "Address",
    copy: "Click to copy"
  },
  information: {
    title: "Edit personal information",
    input: "Please input",
    select: "Please select",
    companyName: "Co./Pers. Full Name",
    companyNameEn: "Company name in English",
    companyNameSn: "Company name in short",
    companyNameContact: "Company contact person",
    legalPerson: "Legal representative",
    telePhone: "Tel No.",
    webSite: "Website",
    address: "Address",
    certificate: "BR license",
    personalPassport: "Passport number",
    personalID: "Identification number",
    customerPhone: "Contact No.",
    email: "Email",
    country: "Country",
    city: "City",
    password: "Password",
    submit: "Submit",
    alert: "Please verify your information",
    name: "Name",
    customerNumber: "ID",
    phoneNumber: "Phone",
    availablePoints: "Points",
    pointsTitle: "My points",
    pointsSubTitle: "Points record",
    changeType1: "Points income",
    changeType2: "Points expend",
    changeType3: "Points deduction",
    changeType4: "Points reversal",
    searchBar: "Please input the tracking number",
    validator: "This name has been used. You can choose from the following names or modify it yourself"
  },
  freightInquiry: {
    tableTitle: "Service quote",
    countryName: "Country name",
    cargoCategory: "Transport service",
    placeHolder: "Please select a country",
    divider: "Additional weight",
    col1: "Transport service",
    col2: "Base weight unit",
    col3: "Base weight unit price",
    col4: "Additional weight",
    col5: "Additional weight unit",
    col6: "Transport time",
    day: "days",
    warehouseContact: "Contact person",
    warehousePhone: "Contact number",
    warehouseAddress: "Warehouse address",
    copy: "Click to copy",
    empty: "No data",
    none: "None",
    remark: "Remark"
  },
  cargoInquiry: {
    input: "Please input",
    wbNumber: "Waybill number",
    search: "Search",
    copy: "Copy",
    title1: "Shipping information",
    title2: "Delivery address",
    title3: "Express information",
    title4: "Cargo information",
    title5: "Logistics tracking",
    logisticsStatus: "Logistics status",
    receivingName: "Consignee",
    phoneNumber: "Contact number",
    receivingAddress: "Delivery address",
    boxNumber: "Box number",
    volume: "Volume",
    weight: "Weight",
    pol: "Pol",
    pod: "Pod",
    cargoName: "Item name",
    cargoQuantity: "Item quantity",
    goodsValue: "Item value",
    currency: "Currency",
    quantityUnit: "Unit of quantity",
    numberPackages: "Number of packages",
    chargeableWeight: "Chargable weight",
    copySuccess: "Copy success",
    wbType1: "Air Freight",
    wbType2: "Sea Freight",
    wbType3: "Air To Door",
    wbType4: "Sea To Door",
    wbType5: "Express",
    logisticsState1: "In transit",
    logisticsState2: "Wait for pick up",
    logisticsState3: "Wait for delivery",
    logisticsState4: "Delivery in progress",
    logisticsState5: "Signed",
    signTime: "Signing time",
    updateTime: "Logistics update time",
    viewLogistics: "View logistics",
    allFilter: "All filter",
    dateRange: "Date range type",
    dateType1: "Today",
    dateType2: "Last 7 Days",
    dateType3: "Last 30 days",
    dateType4: "Custom date",
    selectStartDate: "Please select a start date",
    selectEndDate: "Please select an end date",
    to: "to",
    startDate: "Start date",
    endDate: "End date",
    reset: "Reset",
    confirm: "Confirm",
    tab1: "Uncompleted",
    tab2: "Completed",
    year: "",
    month: "",
    day: "",
    inputText: "input the tracking number",
    searchText: "Search",
    filter: "Filter",
  },
  orderDetail: {
    expressNumber: "Express number",
    cargoTrackingNumber: "Cargo tracking number",
    cargoName: "Item name",
    cargoQuantity: "Item quantity",
    goodsValue: "Item value",
    currency: "Currency",
    quantityUnit: "Unit of quantity",
    isUnpack: "Repacking?",
    countryName: "Country name",
    cargoCategory: "Transport service",
    numberPackages: "Number of packages",
    volume: "Volume",
    weight: "Weight",
    chargeableWeight: "Chargeable weight",
    editOrder: "Edit order",
    deleteOrder: "Delete order",
    wbNumber: "Cargo tracking number",
    billState1: "Unpaid",
    billState2: "Paid",
    billState3: "Unreview",
    boxNumber: "No. of box",
    inboundBoxNumber: "No. of inbound box",
    viewLogistics: "Shipment statue",
    viewBillList: "Statement list",
    payBillList: "Pay the bill",
    viewShipping: "Delivery method",
    viewException: "Delivery Exception",
    exceptionTitle: "Exception handling",
    exceptionReason: "The reason for the exception delivery",
    confirmReceipt: "Receive confirmation",
    allFilter: "All filter",
    select: "Please select",
    cargoSelect: "Please select the country name first",
    reset: "Reset",
    confirm: "Confirm",
    shippingAlertTitle: "Please select the delivery method",
    shippingType1: "Pick up at warehouse",
    shippingType2: "Apply for delivery",
    selectAddress: "Select address",
    receivingName: "Consignee",
    phoneNumber: "Contact number",
    receivingAddress: "Delivery address",
    state1: "Incoming",
    state2: "Inbound",
    state3: "In transit",
    state4: "Ready for pick up",
    state5: "Ready for delivery",
    state6: "Completed",
    state7: "Cancelled",
    confirmDelete: "Are you sure to delete the order?",
    inputText: "Please input",
    search: "Search",
    filter: "Filter",
    sideWbNumber: "House Way Bill No",
    exceptionText(val) {
      return "The reassign operation is supported up to 3 times at most. You can also operate " + val + " times";
    },
    eState1: "Reassign",
    eState2: "Return to warehouse",
    exceptionTrim: "The maximum number of reassign is three times",
    payType: "Select payment method",
    onPay: "Pay now",
    paymentOption1: "Alipay",
    paymentOption2: "Wechat",
    viewDetail: "View detail",
    paySuccess: "Payment success",
    payFailure: "Payment fail",
    backHome: "Back to home",
    searchType: "Search conditions",
    serviceFee: "Service charge",
    availablePoints: "Available points",
    deductibleAmount: "Deductible amount",
    taxFeebearingParty: "Tax payer",
    shipper: "Shipper",
    consignee: "Consignee",
    completeOrderGoodsValue: "Please complete the information",
    discount: "First-time order discount"
  },
  goodsForecast: {
    input: "Please input",
    select: "Please select",
    nextStep: "Next step",
    expressNumber: "Express number",
    expressNumberPlaceHolder: "Please input the domestic courier No. for the incoming packages",
    cargoName: "Item name",
    cargoQuantity: "Item quantity",
    goodsValue: "Item value",
    currency: "Currency",
    quantityUnit: "Unit of quantity",
    customUnit: "Custom units",
    boxNumber: "Box number",
    countryName: "Country name",
    cargoCategory: "Transport service",
    productImage: "Product image",
    receivingAddress: "Delivery address",
    submit: "Submit",
    uploaderText1: "Click to upload",
    uploaderText2: "Support JPG and PNG formats, with a maximum size of 10MB.",
    stepperLabel: "Add / Remove",
    other: "Other",
    isUnpack: "Repacking?",
    question: "Remove & repack to save space and cost.",
    createText: "Reminder: Inbound notification complete. check 'waybill' and complete the payment.",
    productCategory: "Product category",
    totalTax: "Estimated taxes",
    taxFeebearingParty: "Tax payer",
    shipper: "Shipper",
    consignee: "Consignee",
    englishOnly: "Only allow input in English",
    translate: "Translate"
  },
  accountList: {
    accountBalance: "Advance freight balance",
    fundType1: "Advance freight",
    fundType2: "Freight payment",
    fundType3: "Exchange entry",
    fundType4: "Exchange expend",
    currency: "Currency",
    balance: "Balance",
    allFilter: "All filter",
    fundTypeStr: "Fund Type",
    reset: "Reset",
    confirm: "Confirm",
    search: "Search",
    filter: "Filter",
    input: "Please input"
  },
  paybillList: {
    totalAmount: "Total amount",
    approvedAmount: "Approved amount",
    billState1: "Unpaid",
    billState2: "Paid",
    billState3: "Unreview",
    subTotalAmount: "Sub-total amount",
    subApprovedAmount: "Sub-approved amount",
    chargeMoney: "Charge items",
    payableBills: "Payable bill",
    dialogCurrencyTitle: "Please select the payment currency",
  },
  calculator: {
    title: "Please input the information to check the price first",
    input: "Please input",
    select: "Please select",
    length: "Long(cm)",
    width: "Width(cm)",
    height: "Height(cm)",
    weight: "Total weight(kg)",
    search: "Search",
    col1: "Country / Region of destination",
    col2: "Base weight unit",
    col3: "Base weight unit price",
    col4: "Additional weight",
    col5: "Additional weight unit",
    col6: "Transport time",
    day: "days",
    empty: "No data",
    remark: "Remark",
    orderBy1: "Price ascending",
    orderBy2: "Price descending",
    packageSize: "Total volume",
    totalFreight: "Estimate freight"
  },
  shopping: {
    isCoupon: "Discount",
    isBrand: "Brand",
    isAttestation: "Attestation",
    isNotEmail: "Please complete your email address first",
    productInfo: "Product information",
    descriptions: "Product description",
    weight: "Weight",
    volume: "Volume",
    quantity: "Quantity",
    inventory: "Inventory",
    none: "None",
    addShop: "Add to Favorites",
    shopCarList: "Shopping cart",
    productList: "Product list",
    msg1: "The product does not have a collection of product prices",
    msg2: "The product has no specifications",
    msg3: "The product price cannot be found in the corresponding product price set",
    msg4: "The SKU category does not match the price SKU length of this product. Please contact the administrator",
    msg5: "The SKU has no subcategories. Please contact the administrator",
    msg6: "The product price SKU cannot be found in the SKU category. Please contact the administrator",
    msg7: "The SKU prices of the goods cannot be found in the collection",
    msg8: "This product is out of stock",
    refresh: "Refresh"
  }
};
export default messages;
